export default __webpack_public_path__ + "static/media/469.a360c329.jpg";